import { HttpErrorResponse } from '@angular/common/http';
import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { PayScheduleHistory, ScheduleInput } from '../models/pay-schedule.model';
import { AuthService } from '../shared/services/auth/auth.service';
import { LocalStoreManager } from '../shared/services/auth/local-store-manager.service';
import { DisplayNotificationService } from '../shared/services/common/notification.service';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { ScheduleService } from '../shared/services/pay-schedules/schedule.service';

@Component({
  selector: 'app-pay-schedule',
  templateUrl: './pay-schedule.component.html',
  styleUrls: ['./pay-schedule.component.css']
})

export class PayScheduleComponent implements OnInit, OnChanges, OnDestroy, AfterContentChecked {

  lastPaySchedule: Array<PayScheduleHistory> = [];
  currentPaySchedule: Array<PayScheduleHistory> = [];
  nextPaySchedule: Array<PayScheduleHistory> = [];
  scheduleInput: ScheduleInput;
  selectedScheduleId = 0;
  actionType = '';
  orgName: string;
  isLoadScheduleValid = false;
  isDeleteScheduleValid = false;
  displayChild = false;
  schedulehistry: PayScheduleHistory;
  payScheduleHistory: PayScheduleHistory[] = [];
  success = false;
  changed = false;
  activeOrg = '';
  readonly todaysDate: Date = new Date();
  readonly cfy: number = this.todaysDate.getFullYear() + (this.todaysDate.getMonth() + 1 > 6 ? 1 : 0);
  lfy: number;
  readonly nfy: number = (this.cfy + 1);
  fySchedule: any;
  // DEFAULT PANEL OPEN
  selectedid = 0;
  @Input() isNewScheduleValid = false;
  isChanged = false;
  createIntro: any;
  intro: any;
  configText: any;
  operators: any;
  fiscalYearList: any;
  currentFy: any;
  initialLoading = true;
  empScheduleId: any;
  accessData: any;
  items: {id: number; heading: string; data: any[], isTabVisible: boolean}[];

  constructor(
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private localStorage: LocalStoreManager,
    private scheduleService: ScheduleService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    this.operators = this.authService.getAccessOperations(1);
    const showEmpScheduleChanges: boolean = this.authService.getDarkKeyValue('Employer Schedule Id');
    this.accessData = { operators: this.operators, showEmpScheduleChanges };
    const config = this.readConfigService.getPayScheduleText();
    this.createIntro = config.CreateIntro;
    this.intro = config.Instructions;
    this.configText = config.DeleteSchedule;
    this.changeDDwnStage(true);
    this.isChanged = false;
    this.getFiscalYearList();
    this.getItems();
  }

  getItems() {
    this.items = [
      { id: this.lfy, heading: 'Previous Fiscal Year - ', data: [], isTabVisible: false },
      { id: this.cfy, heading: 'Current Fiscal Year - ', data: [], isTabVisible: false },
      { id: this.nfy, heading: 'Next Fiscal Year - ', data: [], isTabVisible: false }];
  }

  setTabStripStyle() {
    const elArr = [];
    const tabstripEls = document.querySelectorAll('.k-tabstrip>.k-tabstrip-items .k-item');
    if (tabstripEls.length > 1) {
      tabstripEls.forEach(element => { elArr.push(element as HTMLElement); });
      elArr.forEach(element => {
        element.style.width = 100 / this.items.length + '%';
      });
    }
  }

  ngOnDestroy(): void {
    this.localStorage.deleteData('CurrentComponent');
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  ngOnChanges(): void {
    this.loadSchedules(this.authService.currentOrg, this.currentFy);
  }

  getFiscalYearList() {
    this.notificationService.setUpLoading(true);
    const obj = { userInfo: this.scheduleService.UserInfo() };
    this.scheduleService.getFYList(obj).subscribe(response => {
      if (response && response.success) {
        const fyList = JSON.parse(`[${response.fys}]`);
        this.fiscalYearList = fyList;
        this.currentFy = this.fiscalYearList.find(element => element === this.cfy);
        this.loadSchedules(this.authService.currentOrg, this.currentFy);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  loadSchedules(orgId: string, selectedFiscalYear: number): void {
    this.notificationService.setUpLoading(true);
    this.displayChild = false;
    this.activeOrg = orgId;
    const inputData = { fiscalYear: selectedFiscalYear, userInfo: this.scheduleService.UserInfo() };
    this.scheduleService.getScheduleList(inputData).subscribe(response => {
      if (response && response.statusCode === 200) {
        const result = response.result;
        this.payScheduleHistory = result.schedules;
        this.items[0].data = [];
        this.items[0].isTabVisible = false;
        this.items[1].data = [];
        this.items[1].isTabVisible = false;
        this.items[2].data = [];
        this.items[2].isTabVisible = false;
        this.orgName = result.organization;
        if (this.payScheduleHistory.length > 0) {
          this.payScheduleHistory.forEach((element: any) => {
            element.oldEmpSchId = element.employerScheduleID;
            if (this.cfy > element.fiscalYear) {
              this.lfy = element.fiscalYear;
            }
            switch (element.fiscalYear) {
              case this.lfy:
                this.items[0].id = this.lfy;
                this.items[0].isTabVisible = this.cfy > this.lfy;
                this.items[0].data.push(element);
                break;
              case this.cfy:
                this.items[1].isTabVisible = (this.cfy === this.currentFy);
                this.items[1].data.push(element);
                break;
              case this.nfy:
                this.items[2].isTabVisible = this.cfy < this.nfy;
                this.items[2].data.push(element);
                break;
            }
          });
          this.fySchedule = this.items.filter(x => x.isTabVisible);
        } else {
          this.items[0].id = (this.cfy > this.currentFy) ? this.currentFy : this.items[0].id;
          const payScheduleFY = this.items.filter(x => x.id === this.currentFy)[0];
          payScheduleFY.isTabVisible = true;
          this.fySchedule = [payScheduleFY];
        }
        if (this.success) {
          const selectData = result.schedules.filter((x: any) => x.id === this.selectedScheduleId)[0];
          this.selectedid = this.selectedScheduleId;
          this.loadScheduleDetails(selectData, 'View');
          this.success = false;
        }
      } else {
        this.notificationService.setErrorNotification();
      }
      this.setTabStripStyle();
      this.notificationService.setUpLoading(false);
      this.initialLoading = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.setTabStripStyle();
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
        this.initialLoading = false;
      });
  }

  fiscalYearChange(value: any) {
    if (value) {
      this.currentFy = value;
      this.loadSchedules(this.authService.currentOrg, this.currentFy);
    }
  }

  createNewSchedule(): void {
    this.notificationService.setUpLoading(true);
    this.newSchedule('Create');
    document.getElementById('scheduleDetails').scrollIntoView();
  }

  newSchedule(actionType: string): void {
    this.notificationService.setUpLoading(true);
    const scheduleInput = new ScheduleInput();
    scheduleInput.cfy = this.cfy;
    scheduleInput.nfy = this.nfy;
    const id = (actionType === 'Create') ? 0 : this.schedulehistry.id;
    const obj = { userInfo: this.scheduleService.UserInfo() };
    this.scheduleService.getScheduleInputs(obj)
      .subscribe(data => {
        if (data && data.statusCode === 200) {
          const scheduleInputResult = data.result;
          scheduleInput.locs = scheduleInputResult.locations;
          scheduleInput.systems = scheduleInputResult.systems;
          scheduleInput.payFrequencies = scheduleInputResult.payFrequencies;
          scheduleInput.orgId = this.authService.currentOrg;
          scheduleInput.orgName = this.orgName;
          this.actionType = actionType;
          this.scheduleInput = scheduleInput;
          this.isNewScheduleValid = true;
          this.isLoadScheduleValid = false;
          this.selectedScheduleId = id;
          this.displayChild = true;
        } else {
          this.notificationService.setErrorNotification();
        }
        this.notificationService.setUpLoading(false);
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.notificationService.setUpLoading(false);
          this.notificationService.setErrorNotification();
        });
  }

  continueSchedule(psHistory: PayScheduleHistory, action: string): void {
    this.schedulehistry = psHistory;
    this.newSchedule(action);
  }

  loadScheduleDetails(psHistory: PayScheduleHistory, action: string): any {
    const id = psHistory.id;
    const filterRecord = this.payScheduleHistory.filter(x => x.id === id);
    if (action === 'View' && filterRecord[0].oldEmpSchId === filterRecord[0].employerScheduleID) {
      this.empScheduleId = filterRecord[0].oldEmpSchId;
    } else {
      this.empScheduleId = filterRecord[0].oldEmpSchId;
    }
    if (id !== this.selectedScheduleId || this.success) {
      this.selectedScheduleId = id;
      this.actionType = action;
      this.schedulehistry = psHistory;
    }
    this.isLoadScheduleValid = true;
    this.isDeleteScheduleValid = action === 'Delete';
    this.isNewScheduleValid = false;
    this.displayChild = true;
  }

  EditSchedule(psHistory: PayScheduleHistory): void {
    this.schedulehistry = psHistory;
    this.notificationService.setUpLoading(true);
    this.newSchedule('Edit');
  }

  displayResult(event: any) {
    if (event.response.success) {
      this.loadSchedules(this.authService.currentOrg, event.fiscalYear);
    }
  }

  scheduleUpdate(event: any): void {
    const args = event.response;
    this.changeDDwnStage(true);
    if (!args) {
      this.displayChild = args;
    } else {
      if (args.success) {
        this.selectedScheduleId = parseInt(args.id, 0);
        this.success = args.success;
        if (event.type.toLowerCase() === 'create') {
          this.currentFy = event.scheduleYear;
        } else if (event.type.toLowerCase() === 'continue') {
          this.currentFy = this.nfy;
        } else if (event.type.toLowerCase() === 'edit') {
          this.currentFy = event.editScheduleYear;
        }
        this.loadSchedules(this.authService.currentOrg, this.currentFy);
        if (document.getElementById('k-panelbar-0-item-' + args.id)) {
          document.getElementById('k-panelbar-0-item-' + args.id).scrollIntoView();
        }
      }
    }
  }

  createScheduleCancel(args: any) {
    if (args === false) {
      this.notificationService.setUpLoading(true);
    }
  }

  recieveDeleteEvent(args: any): void {
    this.isDeleteScheduleValid = false;
    if (args === false) { return; }
    if (args.success) {
      this.isLoadScheduleValid = !args.success;
      this.loadSchedules(this.authService.currentOrg, this.currentFy);
    }
  }

  changesMade(args: any): void {
    if (args !== this.isChanged) {
      this.changeDDwnStage(!args);
    }
  }

  changeDDwnStage(args: boolean) {
    this.isChanged = !args;
    this.authService.formChanged(args);
  }
}
